import React from "react";
import "./index.css";
import { Form, FormGroup, Modal } from "reactstrap";
import { ClipLoader } from "react-spinners";
import { Formik } from "formik";

const InvoiceSettingModal = (props) => {
  const {
    success,
    message,
    isOpen,
    onHide,
    toggleModal,
    handleClose,
    name,
    onPress,
    msg,
    setVersion,
    version,
    loader,
  } = props;

  return (
    <Modal
      isOpen={isOpen}
      onHide={onHide}
      className=" toastDiv settingModalMargin"
      toggle={toggleModal}
      aria-labelledby="myModalLabel2"
      style={{
        width: "33rem",
        borderRadius: "10px",
        backgroundColor: "white",
        alignSelf: "center",
      }}
    >
      <div
        className="modal-content"
        style={{ width: "15rem", backgroundColor: "white" }}
      >
        <text
          className="FontBold"
          style={{
            paddingTop: "1.5rem",
            lineHeight: "32px",
            fontSize: "24px",
            fontFamily: "nunito-regular",
            color: "#2E7C7B",
            paddingBottom: "1.5rem",
            alignSelf: "center",
          }}
        >
          Invoice Number Settings
        </text>
        <div
          style={{
            width: "100%",
            height: "1px",
            border: ".5px solid #6C6C6C33",
          }}
        ></div>
        <Formik
          enableReinitialize
          //   validationSchema={validationSchema}
          initialValues={{
            invoiceNo: props?.fetchInvoiceNo || "",
          }}
          onSubmit={(values) => {
          }}
        >
          {({
            handleBlur,
            handleChange,
            handleSubmit,
            values,
            touched,
            isValid,
            errors,
            setFieldValue,
          }) => (
            <Form
              onSubmit={handleSubmit}
              style={{ marginTop: "50px", padding: "0 75px 0 50px" }}
            >
              <FormGroup
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <FormGroup>
                  <div className="row">
                    <div className="col-4">
                      <label for="invoiceNo" className="heading3 semiBold">
                        Inovice Prefix
                      </label>
                    </div>
                    <div
                      className="col-8"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                    >
                      <input
                        type="text"
                        id="invoiceNo"
                        className={`inputBoxCust1 ${
                          touched.invoiceNo && errors.invoiceNo ? "is-invalid" : ""
                        }`}
                        name="invoiceNo"
                        onChange={handleChange("invoiceNo")}
                        value={values.invoiceNo}
                        touched={touched.invoiceNo}
                        errors={errors.invoiceNo}
                        placeholder="Invoice No"
                      />
                    </div>
                  </div>
                </FormGroup>
                
              </FormGroup>
              <FormGroup style={{
                display : "flex",
                justifyContent: "space-evenly"
              }}>
              <div
            onClick={() => {
              onPress(values?.invoiceNo)
            }}
            style={{
              backgroundColor: "#2E7C7B",
              color: "white",
              paddingTop: ".5rem",
              paddingBottom: ".5rem",
              borderRadius: "10px",
              cursor: "pointer",
              border: ".5px solid #2E7C7B",
              display: "flex",
              alignItems: "center",
              width: "150px",
              justifyContent: "center",
            }}
          >
            {loader ? (
              <>
                <ClipLoader
                  color={"#fff"}
                  loading={true}
                  size={20}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              </>
            ) : (
              "Confitm"
            )}
          </div>
          <div
            onClick={handleClose}
            style={{
              backgroundColor: "white",
              color:  "#2E7C7B",
              paddingTop: ".5rem",
              paddingBottom: ".5rem",
              borderRadius: "10px",
              border: ".5px solid #2E7C7B",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              width: "150px",
              justifyContent: "center",
            }}
          >
            Cancel
          </div>
              </FormGroup>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
};
export default InvoiceSettingModal;
